<template>
  <div v-if="(!isSoldOut && isAvailableToday) || !isBookableExternaly">
    <div class="tickets" v-if="areDateAndTimeSelected() && typeof tour.tickets !== 'undefined'">
      <template v-if="Object.keys(tour.tickets).length > 0">
        <div class="ticket" v-for="ticketId in tour.ticketOrder" :key="ticketId">
          <div class="content">
            <div class="name">
              {{ tour.tickets[ticketId].name }}
              <popover
                effect="fade"
                ref="popover"
                class="TourPopoverContainer"
                placement="bottom"
                title=""
                v-if="
                  tour.tickets[ticketId].description_long !== '' &&
                  typeof tour.tickets[ticketId].description_long !== 'undefined'
                "
              >
                <template v-slot:title></template>
                <template v-slot:content>
                  <div
                    class="popoverContent"
                    v-html="tour.tickets[ticketId].description_long"
                  ></div>
                  <div class="popoverActions">
                    <button @click.prevent="closePopover()">
                      <Icon icon="close"></Icon>
                    </button>
                  </div>
                </template>
                <button
                  class="btn roundButton btn-secondary"
                  @click.prevent=""
                  v-if="tour.tickets[ticketId].description_long !== ''"
                >
                  <icon class="iconInfo" icon="info"></icon>
                </button>
              </popover>
            </div>
            <div class="description">{{ tour.tickets[ticketId].description_short }}</div>
          </div>
          <div class="formInputs">
            <div class="price">
              <template
                v-if="
                  !(
                    tour.tickets[ticketId].price === '0' &&
                    typeof tour.tickets[ticketId].subtickets !== 'undefined'
                  )
                "
                >{{ formatCurrency(tour.tickets[ticketId].price) }}</template
              >
            </div>
            <NumberInputWithButtons
              v-if="typeof tour.tickets[ticketId].subtickets === 'undefined'"
              :model-value="this.formTickets[ticketId].count"
              @input="setFormTicketCountLocal({ id: tour.tickets[ticketId].id, count: $event })"
              :addDisabled="isTicketCountMoreThanAvailableTickets()"
            ></NumberInputWithButtons>
          </div>
          <div class="subtickets" v-if="typeof tour.tickets[ticketId].subtickets !== 'undefined'">
            <Subticket
              v-for="subticket in tour.tickets[ticketId].subtickets"
              :ticketId="parseInt(tour.tickets[ticketId].id, 10)"
              :key="subticket.id"
              :subTicket="subticket"
            ></Subticket>
          </div>
        </div>
      </template>

      <div class="alerts">
        <Alert :condition="isUnderBooking() && hasSetTicketCount">
          {{ $t('GUIDED_TOUR_UNDERBOOKING_MSG_PART1') }} <b>{{ tour.min_participants }}</b>
          <span v-if="parseInt(tour.min_participants, 10) === 1">
            {{ $t('GUIDED_TOUR_UNDERBOOKING_MSG_PART2_SINGULAR') }}
          </span>
          <span v-else>
            {{ $t('GUIDED_TOUR_UNDERBOOKING_MSG_PART2_PLURAL') }}
          </span>
        </Alert>
        <template v-if="typeof calendarDatesAndTimes[formDate] !== 'undefined'">
          <Alert
            :condition="
              (ticketCount >
                parseInt(calendarDatesAndTimes[formDate][formTime].tickets, 10) * tourCount ||
                isTicketCountMoreThanAvailableTickets()) &&
              parseInt(tour.booking_without_tickets, 10) === 0
            "
          >
            {{ $t('GUIDED_TOUR_OVERBOOKING_TICKETS_MSG_PART1') }} <b>{{ ticketCount }}</b>
            {{ $t('GUIDED_TOUR_OVERBOOKING_TICKETS_MSG_PART2') }}
            <b>{{ calendarDatesAndTimes[formDate][formTime].tickets * tourCount }}</b>
            {{ $t('GUIDED_TOUR_OVERBOOKING_TICKETS_MSG_PART3') }}
          </Alert>
          <Alert
            :condition="
              (ticketCount > parseInt(calendarDatesAndTimes[formDate][formTime].tickets, 10) ||
                isTicketCountMoreThanAvailableTickets()) &&
              parseInt(tour.booking_without_tickets, 10) === 1
            "
          >
            {{ $t('GUIDED_TOUR_OVERBOOKING_PARTICIPANTS_MSG_PART1') }} <b>{{ tourCount }}</b>
            {{ $t('GUIDED_TOUR_OVERBOOKING_PARTICIPANTS_MSG_PART2') }}
            <b>{{ calendarDatesAndTimes[formDate][formTime].tickets }}</b>
            {{ $t('GUIDED_TOUR_OVERBOOKING_PARTICIPANTS_MSG_PART3') }}
          </Alert>

          <Alert
            :condition="
              (ticketCount > parseInt(calendarDatesAndTimes[formDate][formTime].tickets, 10) ||
                isTicketCountMoreThanAvailableTickets()) &&
              parseInt(tour.booking_without_tickets, 10) === 1
            "
          >
            {{ $t('GUIDED_TOUR_OVERBOOKING_PARTICIPANTS_MSG_PART1') }} <b>{{ tourCount }}</b>
            {{ $t('GUIDED_TOUR_OVERBOOKING_PARTICIPANTS_MSG_PART2') }}
            <b>{{ calendarDatesAndTimes[formDate][formTime].tickets }}</b>
            {{ $t('GUIDED_TOUR_OVERBOOKING_PARTICIPANTS_MSG_PART3') }}
          </Alert>
        </template>
        <Alert :condition="isLessTicketsThanTours">
          {{ $t('GUIDED_TOUR_LESS_TICKETS_THAN_TOURS_MSG') }}
        </Alert>
        <Alert :condition="isMoreTicketsThanTours">
          {{ $t('GUIDED_TOUR_MORE_TICKETS_THAN_TOURS_MSG') }}
        </Alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import formater from '../../lib/formater';
import NumberInputWithButtons from '../Form/NumberInputWithButtons.vue';
import Subticket from './GuidedTourSubTicket.vue';
import popover from '../Vuestrap-TemporaryFix/Popover.vue';
import Icon from '../Icon.vue';
import Alert from '../Alert.vue';

export default {
  name: 'GuidedTourFormTickets',
  components: {
    Alert,
    NumberInputWithButtons,
    Subticket,
    popover,
    Icon,
  },
  data() {
    return {
      hasSetTicketCount: false,
    };
  },
  computed: {
    ...mapState({
      formDate: (state) => state.guidedTours.form.date,
      formTime: (state) => state.guidedTours.form.time,
      tour: (state) => state.guidedTours.data.single,
      formTickets: (state) => state.guidedTours.form.tickets,
      calendarDatesAndTimes: (state) => state.guidedTours.data.singleCalendar,
      ticketCount: (state) => state.guidedTours.form.ticketCount,
      tourCount: (state) => state.guidedTours.form.tourCount,
    }),
    ...mapGetters({
      isLessTicketsThanTours: 'guidedTours/isLessTicketsThanTours',
      isMoreTicketsThanTours: 'guidedTours/isMoreTicketsThanTours',
      isAvailableToday: 'guidedTours/isAvailableToday',
      isSoldOut: 'guidedTours/isSoldOut',
    }),

    isBookableExternaly() {
      if (parseInt(this.tour.isBookable, 10) === -1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      setFormTicketCount: 'guidedTours/setFormTicketCount',
    }),
    setFormTicketCountLocal(v) {
      this.hasSetTicketCount = true;
      this.setFormTicketCount(v);
    },
    formatCurrency(val) {
      return formater.currency(val);
    },
    areDateAndTimeSelected() {
      if (typeof this.formTime !== 'undefined' && typeof this.formDate !== 'undefined') {
        return true;
      }
      return false;
    },
    getTicketCount(id) {
      return this.formTickets[id].count;
    },
    isTicketCountMoreThanAvailableTickets() {
      if (typeof this.calendarDatesAndTimes[this.formDate] !== 'undefined') {
        if (typeof this.formDate === 'undefined' || typeof this.formTime === 'undefined') {
          return false;
        }
        if (
          this.ticketCount >
          parseInt(this.calendarDatesAndTimes[this.formDate][this.formTime].tickets, 10) *
            this.tourCount
        ) {
          return true;
        }
      }
      return false;
    },
    isUnderBooking() {
      if (
        parseInt(this.tour.book_complete_tour, 10) === 1 &&
        parseInt(this.tour.single_ticketing, 10) === 0
      ) {
        return false;
      }
      if (
        parseInt(this.tour.booking_without_tickets, 10) === 0 &&
        this.ticketCount < parseInt(this.tour.min_participants, 10)
      ) {
        return true;
      }
      if (
        parseInt(this.tour.booking_without_tickets, 10) === 1 &&
        this.tourCount < parseInt(this.tour.min_participants, 10)
      ) {
        return true;
      }

      return false;
    },
    closePopover() {
      // not fancy but works. trigger close on child
      if (typeof this.$refs.popover.toggle !== 'undefined') {
        if (this.$refs.popover.show) {
          this.$refs.popover.toggle();
        }
      } else if (Array.isArray(this.$refs.popover)) {
        this.$refs.popover.forEach((po) => {
          if (po.show) {
            po.toggle();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';

.name,
.price {
  font-weight: 600;
}

.ticket:nth-child(even) {
  background-color: $secondary-block-color-2;
}

.ticket:nth-child(odd) {
  background-color: $secondary-block-color-1;
}

.alerts {
  padding-top: $sp;
}

.ticket {
  padding-top: $sp;
  padding-bottom: calc($sp/2);
  padding-left: $sp;
  /*@extend .row; */
  margin-left: 0;
  margin-right: 0;
  display: flex;
  flex-wrap: wrap;
  .content {
    flex-basis: 60%;
    /*@extend .col-sm-7;
@extend .col-xs-12;
@media screen and (max-width: $screen-sm) {
float: none;
}*/
  }
  .formInputs,
  .values {
    flex-basis: 40%;
    padding-right: $sp;
    //max-width: 20em;
    @media screen and (max-width: $screen-sm) {
      flex-basis: 100%;
      margin-top: $sp;
      margin-left: auto;
      margin-right: auto;
      float: none;
    }
    .price {
      text-align: center;
    }
  }
  .subtickets {
    padding-top: $sp;
    flex-basis: 100%;
  }
}
.popoverActions {
  padding-top: calc($sp / 2);
  text-align: center;
  button {
    min-width: 100px;
  }
}
.popoverContent {
  font-size: 1.3rem;
  padding-top: $sp;
}
.roundButton {
  margin-left: 0.5em;
  border-radius: 200px;
  line-height: 1;
  font-size: 14px;
  padding: 7px 9px;
}
.roundButton:active,
.roundButton:focus {
  outline: none;
}
</style>
